import React, { useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { useWallet } from 'use-wallet'

import BigNumber from 'bignumber.js'
import Page from 'components/Page'
import PageHeader from 'components/PageHeader'

import { AccountContext } from 'contexts/AccountProvider'
import { PoolListContext } from 'contexts/PoolListProvider'
import { weiToEth } from 'lottery/constants'
import WinningTable from 'components/WinningTable'

import dice from 'assets/img/dice.png'

const MyPool = (props) => {
  const [data, setData] = useState([])
  const [reward, setRiward] = useState(0)
  const { account } = useWallet()
  const { poolsContract } = useContext(AccountContext)
  const { poolList } = useContext(PoolListContext)

  const myWin = async (lotteryPool) => {
    const WinnerEvents = await lotteryPool.getPastEvents('WinnerAnnounced', {
      filter: {
        winner: account.toString(),
      },
      fromBlock: 1,
      toBlock: 'latest',
    })

    const tmpPools = []
    let tmpReward = 0
    const poolListTmp = poolList
    if (WinnerEvents) {
      WinnerEvents.forEach((win) => {
        const key = parseInt(win.returnValues.poolId)
        if (poolListTmp[key]) {
          if (win.returnValues.rewardAmount) {
            tmpReward += win.returnValues.rewardAmount
          }
          if (poolListTmp[key]) {
            poolListTmp[key].reward = win.returnValues.rewardAmount
            poolListTmp[key].transactionHash = win.transactionHash
            tmpPools.push(poolListTmp[key])
          }
        }
      })
      setData(tmpPools)
      setRiward(tmpReward)
      return WinnerEvents
    }
  }
  useEffect(() => {
    if (account && poolList.length > 0) {
      myWin(poolsContract)
    }
  }, [account, poolsContract])

  const history = useHistory()
  const handleGoHome = () => {
    history.push('/')
  }

  return (
    <Page>
      <div>
        <PageHeader
          icon={<img src={dice} height="120" alt="dice" />}
          onClick={handleGoHome}
          title="My Winnings"
          subtitle={
            reward > 0 ? `Sum of reward: ${weiToEth(BigNumber(reward))}` : ''
          }
        />
        {reward > 0 ? <WinningTable data={data} /> : <></>}
      </div>
    </Page>
  )
}

export default MyPool
